import SecureLS from 'secure-ls';

const ls = new SecureLS({ isCompression: false });

export default ls;
